import React, { useMemo } from 'react';
import CustomDatePicker from '../../../../../../../../components/common/CustomDatePicker/CustomDatePicker';
import './StatsFilterBar.scss';

interface FilterOption {
  value: string | number;
  label: string;
}

interface StatsFilterBarProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  selectedProviderId: string;
  onProviderChange: (providerId: string) => void;
  providerOptions: FilterOption[];
}

const formatDateLabel = (dateStr: string): string => {
  if (!dateStr) return '';
  const [year, month, day] = dateStr.split('-').map(Number);
  const d = new Date(year, month - 1, day);
  return d.toLocaleDateString('es-CL', { day: 'numeric', month: 'short' });
};

const formatYear = (dateStr: string): string => {
  if (!dateStr) return '';
  return dateStr.split('-')[0];
};

const StatsFilterBar: React.FC<StatsFilterBarProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  selectedProviderId,
  onProviderChange,
  providerOptions,
}) => {
  const dateRangeSummary = useMemo(() => {
    if (!startDate || !endDate) return '';
    const start = formatDateLabel(startDate);
    const end = formatDateLabel(endDate);
    const year = formatYear(endDate);
    return `${start} – ${end}, ${year}`;
  }, [startDate, endDate]);

  return (
    <div className="flex flex-wrap items-center gap-3 mb-4">
      <span className="text-mp-sm font-medium text-mp-text-muted whitespace-nowrap">
        {dateRangeSummary}
      </span>

      <CustomDatePicker value={startDate} onChange={onStartDateChange} placeholder="Desde" />
      <CustomDatePicker value={endDate} onChange={onEndDateChange} placeholder="Hasta" />

      <select
        value={selectedProviderId}
        onChange={(e) => onProviderChange(e.target.value)}
        className="px-3 py-2 bg-transparent border border-mp-border rounded-mp-md text-mp-sm text-mp-text focus:outline-none focus:border-mp-orange focus:ring-2 focus:ring-mp-orange/10 transition-all duration-200 max-w-[180px] cursor-pointer"
      >
        <option value="">Todos los proveedores</option>
        {providerOptions.map((opt) => (
          <option key={opt.value} value={String(opt.value)}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default StatsFilterBar;
